
declare global {
    interface Window { gtag: any; }
}

export default function gaLog(event:string, params:any={}){

    const gtag:any = window.gtag;

    if(!gtag){
        console.error("There is no gtag function");
        return;
    }

    console.log("Log", event, params);

    try {
        gtag('event', event, params);
    } catch(e){
        console.log(e);
    }

}